import { render } from "./HeroStatusModal.vue?vue&type=template&id=f8495692&scoped=true"
import script from "./HeroStatusModal.vue?vue&type=script&lang=js"
export * from "./HeroStatusModal.vue?vue&type=script&lang=js"

import "./HeroStatusModal.vue?vue&type=style&index=0&id=f8495692&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8495692"]])

export default __exports__